// Utils
import { prettifyPhoneNumber } from '@shopee-user/authentication-utils';
import { required } from '@shopee/validators';
import { phoneOrEmailValidator } from '@shopee-user/validators';
import { isFeatureEnabled } from '@shopee-user/business-customization-logic';
import { Feature } from '@shopee-user/feature-toggle';

export const FORM_CONFIG = [
  {
    name: 'authKey',
    initial: '',
    validators: [
      phoneOrEmailValidator({
        isEmailAllowed: isFeatureEnabled(Feature.LoginByPasswordAllowEmail),
        isPhoneAllowed: isFeatureEnabled(Feature.LoginByPasswordAllowPhone),
        requiredErrorMessage: 'msg_auth_mandatory_field',
        phoneErrorMessage: 'msg_auth_invalid_phone',
        emailErrorMessage: 'msg_auth_invalid_email',
      }),
    ],
    transform: prettifyPhoneNumber,
  },
  {
    name: 'password',
    initial: '',
    validators: [required('msg_auth_mandatory_field')],
  },
];
